import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=26b0edf2&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"
import style0 from "./Accordion.styl?vue&type=style&index=0&id=26b0edf2&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b0edf2",
  null
  
)

export default component.exports